export default __webpack_public_path__ + "giveaway-locales/ru-RU.254d29beea124380af4ebf0e57a38c56.json";